export default "__VITE_ASSET__CpjbZ7jk__"